import { Component, ErrorHandler, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'

import { FirebaseLemonaid } from '../../_angular/service/firebase-lemonaid.service'

import { FirestoreTosite } from '@lemon/core-firebase/model/tosite'
import { WebTositePoistaPyynto, WebTositePoistaVastaus } from '@lemon/core-firebase/model/web-tosite-api'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { LemonTranslationService } from '../../_jaettu-angular/service/lemon-translation.service'
import { TositeLukittuDialog } from '../tosite-lukittu.dialog'

export interface TositePoistaDialogData {
  poistettava: FirestoreTosite
}

@Component({
  templateUrl: './tosite.poista.dialog.html',
  styleUrls: ['./tosite.poista.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TositePoistaDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TositePoistaDialogData,
    private _dialogRef: MatDialogRef<TositePoistaDialog>,
    private _dialog: MatDialog,
    private _errorHandler: ErrorHandler,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _translationService: LemonTranslationService,
    private _dateService: DateService,
    private _currencyService: CurrencyService,
  ) {}

  ngOnInit() {}

  async poista() {
    try {
      const pyynto: WebTositePoistaPyynto = { avain: this.data.poistettava.avain }
      const vastaus = await this._firebaseLemonaid.functionsCall<WebTositePoistaPyynto, WebTositePoistaVastaus>('tositePoistaWeb', pyynto, undefined, 'europe-north1')
      if (vastaus.e === 'locked') {
        this._dialogRef.close()
        this._dialog.open(TositeLukittuDialog)
        return
      }
      if (vastaus.e) {
        throw new Error(`Tositteen ${pyynto.avain} poisto epäonnistui: ${vastaus.e}`)
      }
      this._dialogRef.close(true)
    } catch (err) {
      this._errorHandler.handleError(err)
      this._dialogRef.close()
    }
  }

  annaLokalisoituLeipateksti(): Observable<string> {
    return this._translationService.currentLanguageObservable.pipe(
      map(kieli => {
        const pvm = this._dateService.muotoilePaikallinenPaiva(this.data.poistettava.localPvm, kieli)
        const summa = this._currencyService.formatoiRaha(this.data.poistettava.sum ?? this.data.poistettava.summa, 'EUR', kieli)
        return this._translationService.lokalisoi('kuitit.poista-dialog.body', { pvm: pvm, summa: summa })
      }),
    )
  }
}
